export class Responsavel {
    NomeCompleto:string;
}